import { TweenMax } from "gsap/all";

export default {

	init() {

		var container = document.querySelector('.holidayBar');

		if( container ) {

			function contentAnimation( container ) {

				var content = container.querySelector('.holidayBar__content');
				var carousel = content.querySelector('.content__carousel');

				var text = carousel.querySelector('p');
				var textClone = text.cloneNode(true);
				textClone.classList.add('clone');

				var textStyle = null;
				var textHeight = 0;
				var textWidth = 0;
				var timePerPx = 74.5;
				var animationTime = 0;

				// -- functions -- // 

					function getStyle() {

						textStyle = getComputedStyle( text );

						textHeight = parseFloat( textStyle.height.replace('px','') );
						textWidth = parseFloat( textStyle.width.replace('px','') );

						content.style.height = textStyle.height;

					}
					getStyle();

					function cloneContent() {

						carousel.appendChild( textClone );

					}
					cloneContent();

					function setAnimationTime() {
						
						animationTime = textWidth / timePerPx;
						textAnimation();

					}
					setAnimationTime();
					

				// -- END -- // 



				// -- TweenMax -- // 

					function textAnimation() {

						TweenMax.to( carousel, animationTime, {x:-carousel.offsetWidth, repeat:-1, ease:Linear.easeNone} );

					}

				// -- END -- //


				// -- resize -- //

					window.addEventListener('resize', function() {

						getStyle();	

					});

				// -- END -- //


			}

			contentAnimation( container );

		}

	}

}